import { Dialog } from "@bigbinary/neeto-atoms";

import Menu from "./Menu";

const Modal = ({ isOpen, onClose }) => (
  <Dialog
    {...{ isOpen, onClose }}
    aria-describedby={undefined}
    className="sm:max-w-4xl"
    closeButton={false}
  >
    <Dialog.Title className="sr-only">Product Switcher</Dialog.Title>
    <div data-testid="product-switcher-modal">
      <Menu />
    </div>
  </Dialog>
);

export default Modal;
